import { Interceptor } from "@core/api/interceptors/interceptor";
import { PtStatus, RegistrationStatus } from "@domain/user/user";
import { UserStatusManager } from "@domain/user/user-status-manager";
import { isNotNil } from "@utils/assert";
import { AxiosResponse } from "axios";

export const getHcpStatusInterceptor: (
	userStatusManager: UserStatusManager,
) => Interceptor<AxiosResponse> = userStatusManager => ({
	onFulfilled: async (response: AxiosResponse) => {
		const ptHcpStatusHeaderValue: string | undefined = response.headers["x-pt-hcp-status"];
		if (isNotNil(ptHcpStatusHeaderValue)) {
			const hcpStatus = RegistrationStatus[ptHcpStatusHeaderValue as keyof typeof RegistrationStatus];
			if (isNotNil(hcpStatus)) {
				userStatusManager.updateHcpStatus(hcpStatus as PtStatus);
			}
		}
		return response;
	},
});
